import React, { useContext, useEffect, useRef } from 'react';
import TrackingContext from './TrackingContext';
import UserContext from './UserContext';

const UserTracker = () => {
  const tracking = useContext(TrackingContext);
  const { user, userData, loading, loggingIn } = useContext(UserContext);
  const prevUser = useRef<typeof user>(null);
  const prevUserData = useRef<typeof userData>(null);
  const prevUserTracking = useRef<typeof tracking>(null);
  const prevUserDataTracking = useRef<typeof tracking>(null);
  useEffect(() => {
    if (!loggingIn && (user !== prevUser.current || tracking !== prevUserTracking.current)) {
      tracking.trackUser(user?.uid, user ? { email: user?.email } : undefined);
      prevUser.current = user;
      prevUserTracking.current = tracking;
    }
  }, [user, loggingIn, tracking]);
  useEffect(() => {
    if (
      !loading &&
      userData &&
      (userData.pricingPlanId !== prevUserData.current?.pricingPlanId || tracking !== prevUserDataTracking.current)
    ) {
      tracking.trackUser(userData.id, { pricingPlanId: userData.pricingPlanId });
      prevUserData.current = userData;
      prevUserDataTracking.current = tracking;
    }
  }, [userData, loading, tracking]);

  return <></>;
};

export default UserTracker;
